'use client'

import dynamic from "next/dynamic"

const HeaderNoSSR = dynamic(() => import("@/app/_components/header"), {
    ssr: false,
})

export default function HeaderNoSsr() {
    return <HeaderNoSSR />
}